import { styled } from '@mui/material/styles';

import TickFilledIcon from '~/assets/icons/TickFilledIcon';

const sizes = {
  xs: 22,
};

const CompletedTick = styled(TickFilledIcon, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: 'xs' }>`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 5;
  width: ${({ size }) => sizes[size]}px;
  height: ${({ size }) => sizes[size]}px;
`;

export default CompletedTick;
